import React, { useState } from "react";
import { Row, Col, Card, CardBody, CardTitle, Container, Label, FormGroup, InputGroup, Button, Input, Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Dropzone from "react-dropzone";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import Select from "react-select";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import toastr from 'toastr'
import { AddNews, UploadImgNew, DeleteNews, UpdateNews } from "../../services/NewsServices/Api";
import jsonfile from '../../assets/rabatzooapp-3fab1-10ce04426862.json'
import axios from "axios";
import { Table } from "reactstrap";
import config from '../../config';



toastr.options = {
    positionClass: "toast-bottom-right",
    closeButton : true
  }

const Evenment = () => {
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [selectedMulti, setSelectedMulti] = useState([]);
    const [newsList, setNewsList] = useState([]);
    const [titleNews, setTitleNews] = useState('')
    const [desc, setDesc] = useState('')
    const [searchTerm, setSearchTerm] = useState("");
    const [showForm, setShowForm] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedNews, setSelectedNews] = useState(null);
    const [img, setImage] = useState('');  // Nouveau état pour l'image
    const [selectedImage, setSelectedImage] = useState(null);
    const [news, setNews] = useState([]);
    //const response = await instance.delete(`/rabat-zoo/news/api/delete/${newsId}`);
    const [errorsizeFile, seterrorsizeFile] = useState(false)


    const [optionGroup, setOptionGroup] = useState([
        { label: "Public", value: "public" },
        { label: "Producteur", value: "producteur" },
        { label: "Consommateur", value: "consommateur" },
        { label: "Association", value: "association" },
        { label: "Coopérative", value: "cooperative" }
    ]);


    // Fonction pour récupérer les données de l'API
    const fetchNews = async () => {
        try {
          const response = await axios.get("http://152.228.217.114:10002/rabat-zoo/news/api/all");

          // Filtrer les actualités pour exclure celles qui sont désactivées ou cachées
          const filteredNews = response.data.filter(news => !news.disable && !news.hide);

          // Mettre à jour l'état avec les actualités filtrées
          setNewsList(filteredNews);
        } catch (error) {
          console.error("Erreur lors de la récupération des news:", error);
        }
      };


    function base64UrlEncode(str) {
        return btoa(str)
          .replace(/\+/g, '-')
          .replace(/\//g, '_')
          .replace(/=+$/, '');
      }

      function str2ab(str) {
        const buf = new ArrayBuffer(str.length);
        const bufView = new Uint8Array(buf);
        for (let i = 0, strLen = str.length; i < strLen; i++) {
          bufView[i] = str.charCodeAt(i);
        }
        return buf;
      }

      function arrayBufferToBase64(buffer) {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        for (let i = 0; i < bytes.byteLength; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        return btoa(binary);
      }

      // Main function to get the JWT token
      async function getToken() {
        let authConfig = {
          type: "service_account",
          project_id: "rabatzooapp-3fab1",
          private_key_id: "10ce044268627e41263eb59fc1155dc9da74eebc",
          private_key: "-----BEGIN PRIVATE KEY-----\nMIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQDBPNM3Qy/Ob/1/\nBEvyQBjoJIOD2s9jByZOCMjnEI7RYIxSJAJBDc+daKneqo6zpQ9K9Z+gYqvB831Z\ng/OA1NIrZRLzhiAZw50jDa0/2T0Azo/oays/8hH6cxY2FUNruUCbTM7uf8fRbr25\nFKca1k3PEX/3Xei0QBjris9coZd6EIwwsRCG1Kf7SXLhtZIJ7X7rajX/cJeI+JCM\nfqAKBeZ5Iz6faEgPKmsndOWc/Rox+QLvPQfLQY+AZnt7rPIKmWVd9GcfFhb9JLNK\naWnW/OXe2Zu2b5q/w5ZRnPjGRGCjpp00zRrDsmNlPrN5BtB6YQn+nLlHazGeqb/o\ndMNJPSPzAgMBAAECggEAFNv+hugjSHsRV708f4WIysJqSfj8SxnR+jl7imngqNxt\nuU42yhP2Fe1e7PDnX6ARQwu5tAQCu3iPzvJt/jm7CEEsZwpS+8UAePC4g3xtV+F0\namfrLsdwRmNXAfaQpRfF0B3d9qPni4WTSF/g3AZHNvOSJz9FZ/PFXOPKl5q/8caY\nYrCqcub9oNc3HV3aX61TcIC9wM6GfTUkRm8iakWC3ZLRU1CgA7JE2yhbdoAZ4mm2\n4oSVeoEwqZz036UCKuCUTTp6TZ8szQ+RyfSOfWuGaEKQlLHs47ggTZ+sVB+fFR3T\nIk4tzdi+Fs9l3gdtEKiL38eFODBiLZWp1TWMOKo13QKBgQDt8pTTRIXw80t9Kh75\nhaKgId8EZ8Too6TBexj7OGDZ3EX2+W9FGJdNn2mJaKhSqC62sD5jc71yMI49imnE\n+c6gaHIJk76sjuBGa6QYiyy0/3VsmpIfFcGnpBJDtM91teRxfJAm2SBKnRQfOq84\n4yCqKEau4zfSTEw+PbyoENh3BQKBgQDP5eLhBIWEnJjENhjEbYGGhFlWe4/YX/6E\ns83wLihdSXwIaHCPJ8cc+SMOzpvxqJlq3o8wMt8QDoYsAippzvXTGMM/DcH4F3Fk\nZtY8lJC1UoBAk9KR4JNvyBXYaVZCrALmJZTvkrDI/Tvn6K22T1hh/yPVBvHhRJWB\n/0XVHqYwlwKBgB1+Ero45Q0farzhyqMM0EJe0GCgaASZu+MLWeZRb5exOK7K7eK3\nkJFbb95LLYnJNLkKEUGMZ+/OWuL/0+pJODYjm/bZ7ClBMEUqNFWicnEgtLI4WmIl\n9THNIUJpF8m0ONNkKA3YnasB2yufv3YimLrecRxeJ14WfOC+EDMYm2vtAoGAVUnU\nJ8f5Fow/x88BniPmjU7ib65FNtk6yyoQhEYLXSn2bmSaOMBy2RoEHeD47MzkE4m2\naGmWRToQJSHGUJ4ND0sLXmTAfIzxgeUGYtf3/csYvmVmb14YXjVRcPTV5Ig4sD4e\nuaIOUIZC+0LjcPVgJuPKyWwN8wJ161zUQzhNqYUCgYAE3SygFc2MTZgRb387PCZu\nHILtt5vdnJtVcrbgBHFO8H86+pZ/Q6uNMWjvTwuJ3wiAycA3kjVh9zdTuVK7b6Q2\nbzICExX0iQOCQ5Ulmcpuq8rRODlhBykqs5fXgLa1xBHoK2hKR5Ye8czYjGqJ6Fky\nj4/kMzk6HSDBhXKsMYMhmQ==\n-----END PRIVATE KEY-----\n",
          client_email: "firebase-adminsdk-48zbp@rabatzooapp-3fab1.iam.gserviceaccount.com",
          client_id: "102307208030146586624",
          auth_uri: "https://accounts.google.com/o/oauth2/auth",
          token_uri: "https://oauth2.googleapis.com/token",
          auth_provider_x509_cert_url: "https://www.googleapis.com/oauth2/v1/certs",
          client_x509_cert_url: "https://www.googleapis.com/robot/v1/metadata/x509/firebase-adminsdk-48zbp%40rabatzooapp-3fab1.iam.gserviceaccount.com",
          universe_domain: "googleapis.com",
        };

        try {
          // Load and parse service account details
          const response = await fetch(jsonfile);
          console.log(response);
          const contentType = response.headers.get("content-type");
          if (!contentType || !contentType.includes("application/json")) {
            throw new Error("The response is not JSON.");
          }
          authConfig = await response.json();

          // Rest of your code here...
        } catch (error) {
          console.error("Error:", error);
          return null;
        }
      }


    {/*const handleAcceptedFiles = (files) => {
        const file = files[0]; // Assuming single file upload
        setSelectedImage({
            file: file,
            preview: URL.createObjectURL(file), // Generate preview URL
            name: file.name,
        });
    };*/}
    const htmlFormatBytes = (bytes) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }
    const handleAcceptedFilees = (files) => {
        const updatedFiles = files.map((file) =>
            Object.assign(file, {
                preview: URL.createObjectURL(file), // Crée une URL de prévisualisation pour chaque fichier
            })
        );
        setSelectedFiles(updatedFiles); // Mettez à jour selectedFiles avec les fichiers contenant les URLs de prévisualisation
    };


    const formatBytes = (bytes, decimals = 2) => {
        if (bytes === 0) return "0 Bytes";
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    };

    const handleSendNotification = async (DataPost) => {
        try {
            const token = await getToken();
            if (!token) {
                console.error('Failed to obtain access token');
                alert('Failed to obtain access token');
                return;
            }
            console.log(`Access Token: ${token}`);

            // Add the news using your AddNews API
            const addedNewsResponse = await AddNews(DataPost);
            if (!addedNewsResponse || !addedNewsResponse.data || !addedNewsResponse.data.id) {
                console.error('AddNews response is invalid:', addedNewsResponse);
                throw new Error("Failed to add news or missing response data.");
            }

            console.log('News added successfully:', addedNewsResponse);

            // Prepare the notification data
            const notificationData = JSON.stringify({
                "message": {
                    "topic": "all",
                    "notification": {
                        "title": "Breaking News",
                        "body": `Check out the new story: ${DataPost.title || 'No Title'}`
                    },
                    "data": {
                        "story_id": addedNewsResponse.data.id
                    }
                }
            });

            // Config for Axios request to FCM
            const config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://fcm.googleapis.com/v1/projects/rabatzooapp-3fab1/messages:send',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                data: notificationData
            };

            // Send notification request
            const response = await axios.request(config);
            console.log('Notification sent successfully:', response.data);
            toastr.success("Notification sent successfully!");
        } catch (error) {
            console.error('Error while sending notification:', error);
            toastr.error("Failed to send notification. Check the console for details.");
        }
    };



    useState(() => {
      return () => selectedFiles.forEach(file => URL.revokeObjectURL(file.preview));
    }, [selectedFiles]);

    useState(() => {
        return () => {
            selectedFiles.forEach(file => {
                if (file.preview) URL.revokeObjectURL(file.preview);
            });
        };
    }, [selectedFiles]);

    useState(() => {
      const fetchNews = async () => {
        try {
          const response = await axios.get("http://152.228.217.114:10002/rabat-zoo/news/api/all");
          setNewsList(response.data);
        } catch (error) {
          console.error("Erreur lors de la récupération des news:", error);
          toastr.error("Failed to load news. Please try again later.");
        }
      };
      fetchNews();
    }, []);

    const handleSubmit = async () => {
        if (!validateBeforeSubmit()) return;
        try {
            if (!selectedFiles || selectedFiles.length === 0) {
                toastr.error("Veuillez sélectionner une image");
                return;
            }
            const fileToUpload = selectedFiles[0]?.file || selectedFiles[0];
            const formData = new FormData();
            formData.append('file', fileToUpload);
            const uploadResponse = await UploadImgNew(formData);
            if (!uploadResponse) {
                toastr.error("Échec de l'upload de l'image");
                return;
            }
            const DataPost = {
                description: desc,
                title: titleNews,
                img: uploadResponse // c'est le chemin de l'image
            };
            const addNewsResponse = await AddNews(DataPost);
            if (addNewsResponse.status === 201) {
                toastr.success('La news ' + titleNews + " a bien été ajoutée");
                handleSendNotification();
                setTitleNews('');
                setDesc('');
                setSelectedFiles([]);
                setShowForm(false);
                await fetchNews();
            } else {
                toastr.error("Une erreur est survenue");
            }
        } catch (error) {
            console.error("Erreur:", error);
            toastr.error("Erreur lors de l'ajout de la news");
        }
    };
    const handleAcceptedFiles = (files) => {
        if (files && files.length > 0) {
            const file = files[0];
            if (file.size > 5 * 1024 * 1024) { // 5MB max
                toastr.error("La taille de l'image ne doit pas dépasser 5MB");
                return;
            }
            const updatedFile = Object.assign(file, {
                preview: URL.createObjectURL(file)
            });
            setSelectedFiles([updatedFile]);
            setSelectedImage(updatedFile); // Affiche la prévisualisation instantanément
        }
    };

    const validateBeforeSubmit = () => {
        if (!titleNews.trim()) {
            toastr.error("Le titre est requis");
            return false;
        }
        if (!desc.trim()) {
            toastr.error("La description est requise");
            return false;
        }
        if (selectedFiles.length === 0) {
            toastr.error("Une image est requise");
            return false;
        }
        return true;
    };




    const handleMulti = (selectedOptions) => {
        console.log(selectedOptions)
        setSelectedMulti(selectedOptions);
    };

    const filteredNews = newsList.filter((news) =>
        news.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleFormData = (event, values) => {
        event.preventDefault();

        const formData = {
            files: selectedFiles,
            multiSelect: selectedMulti,
            titre: values.titre,
            lieu: values.lieu,
            description: values.textarea,
            city: values.city,
        };

        console.log("Form Data:", formData);

        setSelectedFiles([]);
        setSelectedMulti(null);
        event.target.reset();

    };

    const DataPost = {
        id: selectedNews?.id || null,
        title: titleNews,
        description: desc,
        imageUrl: img, // URL ou fichier
    };
    const handleAddNews = async () => {
        try {
            const response = await AddNews(DataPost); // Appel de la fonction AddNews
            if (response && response.data) {
                alert('News ajoutée avec succès !');
                // Réinitialiser les champs après succès
                setTitleNews('');
                setDesc('');
                setImage('');
                setSelectedNews(null);
            } else {
                alert('Une erreur est survenue.');
            }
        } catch (error) {
            console.error('Erreur lors de l\'ajout des news:', error);
            alert('Erreur lors de l\'ajout des news. Veuillez vérifier la console.');
        }
    };

    const handleCancel = () => {
      // Réinitialiser l'état pour revenir au tableau des actualités
      setTitleNews("");
      setDesc("");
      setSelectedFiles([]);
      setShowForm(false); // Afficher à nouveau le tableau des actualités
  };

  const toggleModal = () => {
    setModalOpen(!modalOpen);
};

// Méthode pour sauvegarder les modifications
const handleSaveChanges = async () => {
    let imgUrl = img;
    // Si une nouvelle image est sélectionnée, on l'upload
    if (selectedFiles && selectedFiles.length > 0) {
        const fileToUpload = selectedFiles[0]?.file || selectedFiles[0];
        const formData = new FormData();
        formData.append('file', fileToUpload);
        imgUrl = await UploadImgNew(formData);
    }
    const DataPost = {
        id: selectedNews?.id || null,
        title: titleNews,
        description: desc,
        img: imgUrl
    };
    try {
        const response = await UpdateNews(DataPost);
        if (response.status === 200) {
            await fetchNews();
            clearForm();
            toggleModal();
        } else {
            alert("Erreur lors de la sauvegarde des modifications.");
        }
    } catch (error) {
        alert("Une erreur s'est produite lors de la mise à jour de l'actualité.");
    }
};



const handleAddClick = () => {
    clearForm();
    setShowForm(true);
};

const handleEditClick = (news) => {
    setTitleNews(news.title);
    setDesc(news.description);
    setSelectedNews(news);
    setImage(news.img); // Utiliser le champ img
    setSelectedImage(null); // Réinitialiser la sélection d'image
    setModalOpen(true);
    console.log('img value:', news.img);
};

const clearForm = () => {
    setTitleNews("");
    setDesc("");
    setImage(null);
    setSelectedNews(null);
};

// Clean up the preview URL when modal closes or new file is selected
useState(() => {
    return () => {
        if (selectedImage && selectedImage.preview) {
            URL.revokeObjectURL(selectedImage.preview); // Clean up URL when component unmounts
        }
    };
}, [selectedImage]);

const handleDeleteImage = () => {
    setSelectedImage(null); // Assuming selectedImage is a state variable
};

useState(() => {
    setSelectedImage(null); // Clear the image preview when opening a new news item
}, [/* Add dependency here, such as a news item ID or title to detect change */]);

const handleDelete = async (id) => {
    if (!id) {
        console.error("Aucun ID fourni");
        return;
    }
    const userConfirmed = window.confirm("Êtes-vous sûr de vouloir supprimer cette actualité ?");
    if (!userConfirmed) {
        return;
    }
    try {
        await DeleteNews(id);
        toastr.success("Actualité supprimée avec succès !");
        await fetchNews();
    } catch (error) {
        console.error("Erreur de suppression", error);
        toastr.error("Une erreur est survenue lors de la suppression.");
    }
};





    return (
      <React.Fragment>
      <div className="page-content">
          <Container fluid={true}>
              <Row>
                  <Col xs={12}>
                      <Breadcrumbs
                          title="Ajouter actualité"
                          breadcrumbItems={[]}
                      />
                      <Card>
                          <CardBody>
                              {/* Afficher la barre de recherche et le bouton "Ajouter Actualité" si showForm est faux */}
                              {!showForm && (
                                  <Row className="mb-3">
                                      <Col md={6}>
                                          <Input
                                              type="text"
                                              placeholder="Recherche..."
                                              value={searchTerm}
                                              onChange={(e) => setSearchTerm(e.target.value)}
                                          />
                                      </Col>
                                      <Col md={6} className="d-flex justify-content-end">
                                      <Button color="primary" onClick={handleAddClick}>
                                            Ajouter Actualité
                                    </Button>
                                      </Col>
                                  </Row>
                              )}

                              {/* Afficher le formulaire d'ajout d'actualité et le bouton "Sauvegarder" si showForm est vrai */}
                              {showForm && (
                                  <AvForm onValidSubmit={handleFormData}>
                                      <Row>
                                          <Col md={6}>
                                              <Dropzone onDrop={handleAcceptedFilees}>
                                                  {({ getRootProps, getInputProps }) => (
                                                      <div className="dropzone input-uploading input-uplaoding">
                                                          <div className="dz-message needsclick uplaod-button" {...getRootProps()}>
                                                              <input {...getInputProps()} />
                                                              <div className="mb-3 upload-button uplaod-button">
                                                                  <i className="display-4 text-muted ri-upload-cloud-2-line"></i>
                                                              </div>
                                                              <h4>Drop files here or click to upload.</h4>
                                                          </div>
                                                      </div>
                                                  )}
                                              </Dropzone>
                                          </Col>
                                          <Col md={6}>
                                              <div className="dropzone-previews mt-4">
                                                  <Row>
                                                      {selectedFiles.map((file, index) => (
                                                          <Col md={6} key={index} className="mb-3">
                                                              <Card className="shadow-none border dz-success dz-complete">
                                                                  <div className="p-2 displayer-img">
                                                                      <Row className="align-items-center">
                                                                          <Col className="d-flex flex-column align-items-center">
                                                                              <img
                                                                                  height={300}
                                                                                  width={300}
                                                                                  className="rounded bg-light mb-2"
                                                                                  alt={file.name}
                                                                                  src={file.preview}
                                                                                  style={{
                                                                                      objectFit: 'fill',
                                                                                      maxHeight: '300px',
                                                                                      maxWidth: '100%',
                                                                                  }}
                                                                              />
                                                                              <h6>{file.name}</h6>
                                                                          </Col>
                                                                      </Row>
                                                                  </div>
                                                              </Card>
                                                          </Col>
                                                      ))}
                                                  </Row>
                                              </div>
                                          </Col>
                                      </Row>

                                      <Row className="mb-3">
                                          <Col md={12}>
                                              <Label htmlFor="titre-input" className="col-md-2 col-form-label">Titre</Label>
                                              <Input type="text" className="form-control" id="titre-input" value={titleNews} onChange={(e) => setTitleNews(e.target.value)} />
                                          </Col>
                                      </Row>

                                      <Row className="mb-3">
                                          <Col md={12}>
                                              <Label htmlFor="textarea-input" className="col-md-2 col-form-label">Description</Label>
                                              <textarea id="textarea-input" className="form-control" rows="5" onChange={(e) => setDesc(e.target.value)} value={desc}></textarea>
                                          </Col>
                                      </Row>

                                      <div className="d-flex justify-content-end gap-2">
                                          <Button color="success" onClick={handleSubmit}>
                                              Sauvegarder
                                          </Button>
                                          <Button color="secondary" onClick={handleCancel}>
                                              Annuler
                                          </Button>
                                      </div>
                                  </AvForm>
                              )}

                              {/* Afficher la table des actualités uniquement si showForm est faux */}
                              {!showForm && (
                                  <Table className="mt-4" striped>
                                      <thead>
                                          <tr>
                                              <th>id</th>
                                              <th>Titre</th>
                                              <th>Description</th>
                                              <th>Actions</th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          {filteredNews.length > 0 ? (
                                              filteredNews.map((news, index) => (
                                                  <tr key={news.id}>
                                                      <td>{index + 1}</td>
                                                      <td>{news.title}</td>
                                                      <td>{news.description}</td>
                                                      <td>
                                                          <div className="d-flex gap-2">
                                                              <Button color="primary" size="sm" onClick={() => handleEditClick(news)}>
                                                                  Modifier
                                                              </Button>
                                                              <Button color="danger" size="sm" onClick={() => handleDelete(news.id)} className="delete-button">Supprimer</Button>
                                                          </div>
                                                      </td>
                                                  </tr>
                                              ))
                                          ) : (
                                              <tr>
                                                  <td colSpan="4" className="text-center">Aucune news trouvée</td>
                                              </tr>
                                          )}
                                      </tbody>
                                  </Table>
                              )}
<Modal
    isOpen={modalOpen}
    toggle={toggleModal}
    style={{ width: '70%', maxWidth: '1000px', height: 'auto', maxHeight: '500px' }}  // Apply height and max-height here
>
    <ModalHeader toggle={toggleModal}>Modifier Actualité</ModalHeader>
    <ModalBody>
        <AvForm>
            {/* Image Upload Section */}
            <Row className="mb-3 align-items-center">
    <Col md={6} style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ flex: 1 }}>
            <Label>Image</Label>
            <Dropzone onDrop={handleAcceptedFiles}>
                {({ getRootProps, getInputProps }) => (
                    <div
                        className="dropzone input-uploading"
                        {...getRootProps()}
                        style={{
                            border: '2px dashed #ccc',
                            padding: '20px',
                            borderRadius: '5px',
                        }}
                    >
                        <input {...getInputProps()} />
                        <div className="dz-message needsclick">
                            <i className="display-4 text-muted ri-upload-cloud-2-line"></i>
                            <h4>Drop files here or click to upload.</h4>
                        </div>
                    </div>
                )}
            </Dropzone>
        </div>
        <div style={{ marginLeft: 24 }}>
            {selectedImage && (
                <div className="mt-3 position-relative" style={{ display: 'inline-block' }}>
                    <Button
                        color="danger"
                        size="sm"
                        onClick={handleDeleteImage}
                        style={{
                            position: 'absolute',
                            top: '-10px',
                            right: '-10px',
                            borderRadius: '50%',
                            padding: '5px',
                            zIndex: 10,
                        }}
                    >
                        <i className="ri-delete-bin-line" style={{ fontSize: '1rem', color: 'white' }}></i>
                    </Button>
                    <img
                        height={150}
                        className="rounded bg-light"
                        alt={selectedImage.name}
                        src={selectedImage.preview}
                        style={{
                            objectFit: 'fill',
                            maxHeight: '150px',
                            maxWidth: '150px',
                        }}
                    />
                    <h6 className="mt-2">{selectedImage.name}</h6>
                </div>
            )}
        </div>
    </Col>
</Row>

        {/* Title Input */}
        <Row className="mb-3">
            <Col md={12}>
                <Label htmlFor="titre-input">Titre</Label>
                <Input
                    type="text"
                    id="titre-input"
                    value={titleNews}
                    onChange={(e) => setTitleNews(e.target.value)}
                />
            </Col>
        </Row>

        {/* Description Input */}
        <Row className="mb-3">
            <Col md={12}>
                <Label htmlFor="textarea-input">Description</Label>
                <textarea
                    id="textarea-input"
                    className="form-control"
                    rows="5"
                    value={desc}
                    onChange={(e) => setDesc(e.target.value)}
                />
            </Col>
        </Row>
        </AvForm>
    </ModalBody>
    <ModalFooter>
        <Button color="success" onClick={handleSaveChanges}>
            Mise à jour
        </Button>
    </ModalFooter>
</Modal>





                          </CardBody>
                      </Card>
                  </Col>
              </Row>
          </Container>
      </div>
  </React.Fragment>
);
};

export default Evenment;

